import { ShareLibraryType } from '@moovly/clients/lib/resources/libraries/libraries.interfaces';
import { CurrentUserInfo } from '../../../hooks/useCurrentUser';
import { t } from '@moovly/i18n';

interface LibraryShareTypeOption {
  value: ShareLibraryType;
  label: string;
}

export const getLibraryShareTypeOptions: (props: CurrentUserInfo) => LibraryShareTypeOption[] = ({
  isOrganizationAdmin,
}) => {
  const options = [
    {
      value: 'user',
      label: t('libraries.shareType.user'),
    },
    {
      value: 'group',
      label: t('libraries.shareType.group'),
    },
  ];

  if (isOrganizationAdmin) {
    options.push({
      value: 'organization',
      label: t('libraries.shareType.organization'),
    });
  }
  return options as LibraryShareTypeOption[];
};
